import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IECheck } from 'src/app/core/interfaces/payments/IECheck';
import { StateMap } from 'src/app/core/models/constants/app-constants';
import { State } from 'src/app/core/models/enums/State';
import { AutoPopulateService } from 'src/app/core/services/auto-populate.service';
import Utils from 'src/app/shared/utilities/utils';

@Component({
    selector: 'app-echeck-payment',
    templateUrl: './echeck-payment.component.html',
    styleUrls: ['./echeck-payment.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ECheckPaymentComponent implements OnInit {
  @Input() amountDue: number = 0;
  @Output() submitPayment = new EventEmitter<IECheck>();
  public eCheckForm: FormGroup;
  public billingAddressForm: FormGroup;
  public states: string[] = this.getStates();

  //#region Initialization

  constructor(
    private formBuilder: FormBuilder,
    private autoPopulateService: AutoPopulateService
  ) {}

  ngOnInit(): void {
    this.eCheckForm = this.formBuilder.group({
      amount: [this.amountDue, Validators.required],
      name: ['', Validators.required],
      accountNumber: ['', Validators.required],
      routingNumber: ['', [Validators.required, Validators.minLength(9)]]
    });

    this.billingAddressForm = this.formBuilder.group({
      street: ['', Validators.required],
      line2: [''],
      zip: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$')
        ]
      ],
      city: ['', Validators.required],
      state: ['', Validators.required]
    });
  }

  //#endregion Initialization

  //#region Action handlers

  public onSubmitPayment(): void {
    const amount: number = parseFloat(this.eCheckForm.controls['amount'].value);
    const name: string = this.eCheckForm.controls['name'].value;
    const accountNumber: string =
      this.eCheckForm.controls['accountNumber'].value;
    const routingNumber: string =
      this.eCheckForm.controls['routingNumber'].value;
    const street: string = this.billingAddressForm.controls['street'].value;
    const line2: string = this.billingAddressForm.controls['line2'].value;
    const city: string = this.billingAddressForm.controls['city'].value;
    const state: State = this.billingAddressForm.controls['state'].value;
    const zip: string = this.billingAddressForm.controls['zip'].value;

    const payment: IECheck = {
      amount: amount,
      accountOwnerName: name,
      accountNumber: accountNumber,
      routingNumber: routingNumber,
      billingAddress: {
        line1: street,
        line2: line2,
        city: city,
        state: state,
        zipCode: zip
      }
    };

    this.submitPayment.emit(payment);
  }

  public onZipChange(): void {
    const zipCode = this.billingAddressForm.controls.zip.value;
    if (zipCode.length < 5) {
      return;
    }

    this.autoPopulateService
      .getPreferredCityStateFromZip(zipCode)
      .subscribe((response) => {
        if (response.hasData()) {
          const city = Utils.toFullProper(response.data[0].city);
          const state = Utils.removeWhiteSpace(
            StateMap.get(response.data[0].state)
          );

          this.billingAddressForm.patchValue({ city: city });
          this.billingAddressForm.patchValue({ state: state });
        }
      });
  }

  //#endregion Action handlers

  //#region Helpers

  public getStates(): string[] {
    return Object.keys(State).filter((key) => {
      return !Utils.isNumber(key);
    });
  }

  //#endregion Helpers
}
